const StatusRequests = {
  "NOVO": { descricao: "NOVO", cor: "#D4D4D4" }, //bg-neutral-300
  "GESTAO": { descricao: "GESTAO", cor: "#f87171" },
  "BACKOFFICE": { descricao: "BACKOFFICE", cor: "#FBDF49" }, //bg-yellow-300
  "DEPOSITO": { descricao: "DEPOSITO", cor: "#d8b4fe" },
  "REPASSE PARA ENTREGA": { descricao: "REPASSE PARA ENTREGA", cor: "#bae6fd" },
  "ROTA DE ENTREGA": { descricao: "ROTA DE ENTREGA", cor: "#38bdf8" },
  "ENTREGUE": { descricao: "ENTREGUE", cor: "#0369a1" },
  "FINALIZADO": { descricao: "FINALIZADO", cor: "#22c55e" },
  "CANCELADO": { descricao: "CANCELADO", cor: "#5d5d5d" },
  "ENCERRADO": { descricao: "ENCERRADO", cor: "#64748b" }
};

export default StatusRequests;